import { Box } from "@mui-wrapper";
import { withEllipsisMultiline } from "@utils/styles/common-styles";

interface Props {
  /** The header title */
  title: string;
}

/** Generates a simple header with a title */
export function StringHeader({ title }: Props): React.JSX.Element {
  return (
    <Box
      sx={{
        px: 6,
        pt: 2,
        height: "150px",
        fontSize: "1.5rem",
        ...withEllipsisMultiline({ lines: 2 }),
      }}
    >
      {title}
    </Box>
  );
}
